import { PrizeTypes } from "../brandVariables.types";

// const render = () => {
//   return (
//     <>
//       from Lego
//       <sup>
//         <small>®</small>
//       </sup>
//     </>
//   );
// };

export const logitechPrize: PrizeTypes = {
  content: "DRIVE & WIN ",
  // nameOf: "mclaren mp4/4 & ayrton senna", // will be marked in color
  nameOf: "LOGITECH G", // will be marked in color
  typeOfItem: "PRIZES", // will be added after nameOf
};
